import axios from 'axios';
export const requestOpenBadgeV3Signature = async (params) => {
    return axios
        .post(`${params.custodianApiRoot}/signature/${params.wallet}`, {
        certificateId: params.certificateId,
        payloadSchema: 'OPEN_BADGE_V3',
        algorithm: params.algorithm,
        payload: params.payload,
    }, {
        headers: { Authorization: params.accessToken.value() },
    })
        .then((output) => typeof output.data.signature === 'string' ? output.data.signature : JSON.stringify(output.data.signature));
};
export const getNetworkFeeStatus = async (custodianApiRoot, operation) => axios.get(`${custodianApiRoot}/fee/${operation}`).then((r) => r.data);
export const setNetworkOperationThreshold = async (custodianApiRoot, operation, thresholdPerGasInWei, thresholdTotalInMatic, token) => axios
    .post(`${custodianApiRoot}/fee/${operation}`, {
    threshold: thresholdPerGasInWei,
    totalInMatic: thresholdTotalInMatic,
}, { headers: { Authorization: token.value() } })
    .then((r) => r.data);
export const signTransaction = async (custodianApiRoot, //
wallet, transaction, token) => axios
    .post(`${custodianApiRoot}/sign/${wallet}`, transaction, {
    headers: { Authorization: token.value() },
})
    .then((response) => response.data);
export class CustodianUrlBuilder {
    custodianApiRoot;
    constructor(custodianApiRoot) {
        this.custodianApiRoot = custodianApiRoot;
    }
    getPublicKeyByAlgorithm(wallet, algorithm, format = 'jwk') {
        return `${this.custodianApiRoot}/wallet/${wallet}/key/${algorithm}/public?fmt=${format}`;
    }
}
export const getOrCreateWallet = async (custodianApiRoot, //
email) => axios.post(`${custodianApiRoot}/email/${email}`).then((response) => response.data);
export var GET_WALLET_QUERY_STRING_PARAMETERS;
(function (GET_WALLET_QUERY_STRING_PARAMETERS) {
    GET_WALLET_QUERY_STRING_PARAMETERS["USER_ID"] = "id";
    GET_WALLET_QUERY_STRING_PARAMETERS["EMAIL"] = "email";
})(GET_WALLET_QUERY_STRING_PARAMETERS || (GET_WALLET_QUERY_STRING_PARAMETERS = {}));
export const getWallet = async (root, param, value, token) => axios
    .get(`${root}/wallet?${param}=${value}`, {
    headers: {
        Authorization: token.value(),
    },
})
    .then((response) => response.data);
export class DIDBuilder {
    custodianRootApi;
    custodianUrlBuilder;
    constructor(custodianRootApi) {
        this.custodianRootApi = custodianRootApi;
        this.custodianUrlBuilder = new CustodianUrlBuilder(this.custodianRootApi);
    }
    async didKeyForWallet(wallet) {
        return axios
            .get(this.custodianUrlBuilder.getPublicKeyByAlgorithm(wallet, 'ED25519', 'multiKey'))
            .then((response) => response.data);
    }
    async didJwkForWallet(wallet) {
        return axios.get(this.custodianUrlBuilder.getPublicKeyByAlgorithm(wallet, 'RS256')).then((response) => {
            const kidLessJwk = Object.fromEntries(Object.entries(response.data).filter(([key]) => key !== 'kid'));
            const jwkAsBase64Url = Buffer.from(JSON.stringify(kidLessJwk), 'utf-8').toString('base64url');
            const did = `did:jwk:${jwkAsBase64Url}`;
            return {
                did: did,
                jwk: kidLessJwk,
                url: did.concat('#0'),
            };
        });
    }
}
export var KeyAlgorithm;
(function (KeyAlgorithm) {
    KeyAlgorithm["RS256"] = "RS256";
    KeyAlgorithm["ES256K"] = "ES256K";
    KeyAlgorithm["ED25519"] = "ED25519";
})(KeyAlgorithm || (KeyAlgorithm = {}));
//# sourceMappingURL=index.js.map